import React from 'react';
import CommonDragger from '../../components/CommonDragger';
import './style/createApp.less';

const CreateApp = () => {
  return <CommonDragger />;
};

export default CreateApp;
